import { render, staticRenderFns } from "./ProfileSubjectSelection.vue?vue&type=template&id=55666bf1&scoped=true&"
import script from "./ProfileSubjectSelection.vue?vue&type=script&lang=js&"
export * from "./ProfileSubjectSelection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSubjectSelection.vue?vue&type=style&index=0&id=55666bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55666bf1",
  null
  
)

export default component.exports